export default {
  clientes: [],
  cliente: {
    clientePlanos: [],
  },
  pagination: {
    current_page: 1,
    per_page: 15,
  },

  cliente_users: [],
  pagination_users: {
    current_page: 1,
    per_page: 15,
  },

  cliente_pagamentos: [],
  pagination_pagamentos: {},
  error: {},
};
